import axios from 'axios';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import myEnvironmentRoutes from '~/routes/myEnvironment';

export default function useAuthInterceptor() {
  const navigate = useNavigate();

  const onUnauthorized = useCallback(() => {
    navigate(myEnvironmentRoutes.LOGIN);
  }, [navigate]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401) {
          onUnauthorized();
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [onUnauthorized]);
}
